'use client'

import { Alert } from '@mui/material'

export function DoneStep() {
  return (
    <Alert severity="success">
      Votre accès a été désactivé. Toute connexion avec cet appareil est désormais refusée. Contactez votre établissement pour réactiver votre compte.
    </Alert>
  )
}
